import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = { url: String }

  connect() {
    this.itemTargets.forEach(item => {
      item.setAttribute("draggable", "true")
      item.addEventListener("dragstart", this.handleDragStart.bind(this))
      item.addEventListener("dragover", this.handleDragOver.bind(this))
      item.addEventListener("dragenter", this.handleDragEnter.bind(this))
      item.addEventListener("dragleave", this.handleDragLeave.bind(this))
      item.addEventListener("drop", this.handleDrop.bind(this))
      item.addEventListener("dragend", this.handleDragEnd.bind(this))
    })
  }

  handleDragStart(event) {
    this.draggedItem = event.currentTarget
    event.currentTarget.classList.add("opacity-50")
    event.dataTransfer.effectAllowed = "move"
  }

  handleDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
  }

  handleDragEnter(event) {
    event.currentTarget.classList.add("border-blue-400", "bg-blue-50")
  }

  handleDragLeave(event) {
    event.currentTarget.classList.remove("border-blue-400", "bg-blue-50")
  }

  handleDrop(event) {
    event.preventDefault()
    const dropTarget = event.currentTarget
    dropTarget.classList.remove("border-blue-400", "bg-blue-50")

    if (this.draggedItem === dropTarget) return

    // Determine new position from the drop target
    const items = [...this.itemTargets]
    const dragIndex = items.indexOf(this.draggedItem)
    const dropIndex = items.indexOf(dropTarget)

    if (dragIndex < dropIndex) {
      dropTarget.parentNode.insertBefore(this.draggedItem, dropTarget.nextSibling)
    } else {
      dropTarget.parentNode.insertBefore(this.draggedItem, dropTarget)
    }

    // Send reorder request
    const questionId = this.draggedItem.dataset.questionId
    const newPosition = dropIndex + 1
    const url = this.draggedItem.dataset.reorderUrl

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
      },
      body: JSON.stringify({ position: newPosition }),
    }).then(() => {
      // Update position badges
      this.itemTargets.forEach((item, index) => {
        const badge = item.querySelector("[data-position-badge]")
        if (badge) badge.textContent = index + 1
      })
    })
  }

  handleDragEnd(event) {
    event.currentTarget.classList.remove("opacity-50")
    this.itemTargets.forEach(item => {
      item.classList.remove("border-blue-400", "bg-blue-50")
    })
  }
}
